// components/AdminRoute.tsx
// If not logged in as admin → render NotFound (404), NOT a redirect to /login.
// This means /admin is completely invisible to anyone who stumbles on it.

import NotFound from "../pages/NotFound";
import { useAuth } from "../context/AuthContext";

function Spinner() {
  return (
    <div style={{ minHeight: "100svh", background: "#080c12", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <div style={{ width: 36, height: 36, border: "3px solid rgba(139,92,246,0.2)", borderTopColor: "#8b5cf6", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 12, fontFamily: "DM Mono, monospace" }}>Loading...</div>
    </div>
  );
}

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { session, profile, loading } = useAuth();

  // Still initialising auth
  if (loading) return <Spinner />;

  // Session exists but profile hasn't arrived from DB yet.
  // This happens because setSession() re-renders immediately while fetchProfile()
  // is still in-flight — without this guard, AdminRoute shows NotFound in that window.
  if (session && !profile) return <Spinner />;

  // Not admin → show 404, never reveal the admin panel exists
  if (!profile || profile.role !== "admin") return <NotFound />;

  // Admin must have passed the MFA step this session — no nonce = same as 404
  if (!sessionStorage.getItem("admin_mfa_nonce")) return <NotFound />;

  return <>{children}</>;
}
